import { render, staticRenderFns } from "./financeiro-tabela-propria.vue?vue&type=template&id=0f8128c2&scoped=true"
import script from "./financeiro-tabela-propria.vue?vue&type=script&lang=ts"
export * from "./financeiro-tabela-propria.vue?vue&type=script&lang=ts"
import style0 from "./financeiro-tabela-propria.vue?vue&type=style&index=0&id=0f8128c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8128c2",
  null
  
)

export default component.exports